module.exports = __webpack_public_path__ + "static/greetingImage-6d99646d93bb7ac96f75a203b7b4b243.png";